import { render, staticRenderFns } from "./AddShippingModalAddNew.vue?vue&type=template&id=348e16d8&scoped=true&"
import script from "./AddShippingModalAddNew.vue?vue&type=script&lang=js&"
export * from "./AddShippingModalAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348e16d8",
  null
  
)

export default component.exports